import React, { useState } from 'react'

const Navbar = (props) => {
  const [text, setText] = useState('');
  const buttonClk =()=>{
     console.log("clicked");
     let newText = text.toUpperCase();
     setText(newText);
  }
  const buttonClo =()=>{
    console.log("clicked");
    let newText = text.toLowerCase();
    setText(newText);
 }

 const buttonClear =() => {
   let newText= '';
   setText(newText);
 }
  const formHandle = (event) => {
    console.log("onChange");
    setText(event.target.value);
     
  }
    return (
      <>
     
     <nav class={`navbar navbar-${props.mode} bg-${props.mode}`}>
  <div class="container-fluid">
    <a class="navbar-brand">WORDTRACK</a>
    <form class="d-flex">
    <div className="form-check form-switch">
  <input onClick={props.toggle} className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
  </div>
    </form>
  </div>
</nav>






  <div className="container my-3">
  <div className="mb-3">
  <textarea placeholder="Enter the text" value={text} onChange={formHandle} className="form-control" id="exampleFormControlTextarea1" rows="8" 
  style= {{backgroundColor: props.mode==='dark'?'black':'white', color: props.mode==='dark'?'white':'black'}}
  ></textarea>
  <div className="btn btn-primary my-3 mx-2" onClick={buttonClk}>Convert to uppercase</div>
  <div className="btn btn-primary my-3 mx-2" onClick={buttonClo}>Convert to lowercase</div>
  <div className="btn btn-danger my-3 mx-2" onClick={buttonClear}>Clear</div>
</div>
</div>


    <div className="container my-3">
      <h2 style= {{color: props.mode==='dark'?'white':'black'}}>Paragraph description</h2> <br></br>
     <p style= {{color: props.mode==='dark'?'white':'black'}}> No of words : <b>{text.split(' ').length}</b> No of characters : <b>{text.length}</b><br></br>
      Time required to read:<b> {0.008 * text.split(' ').length}</b> Minutes </p>
    </div>

    <div className="container my-3">
      <h2 style= {{color: props.mode==='dark'?'white':'black'}}>Paragraph preview</h2>
      <p style= {{color: props.mode==='dark'?'white':'black'}}>{text.length>0 ?text:"Please type something to preview"}</p>
    </div>

     <center>By <a href="https://github.com/Decoder6125">Decoder</a></center>
      </>
    )
}

export default Navbar
